<template>
    <div class="slider-container">
        <swiper
            :slides-per-view="perView"
            :autoHeight="autoHeight"
            :navigation="showNavigation"
            :pagination="showPagination ? {
                clickable: true,

            } : false"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
            :loop="loop"
            :breakpoints="breakpointOptions"
            :effect="fade ? 'fade' : ''"
            :initialSlide="initialSlideIndex"
            :centeredSlides="centerSlides"
            :slideToClickedSlide="slideToClicked"
        >
            <swiper-slide
                v-for="(slide, sIdx) in slides"
                :key="sIdx"
            >
                <slot :slide="slide" />
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { ref, watch } from 'vue';
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, EffectFade } from 'swiper';

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';

// install Swiper modules
SwiperCore.use([EffectFade, Navigation, Pagination]);

export default {
    name: 'Slider',

    components: {
        Swiper,
        SwiperSlide,
    },

    props: {
        showNavigation: {
            type: Boolean,
            default: false
        },
        showPagination: {
            type: Boolean,
            default: false
        },
        centerSlides: {
            type: Boolean,
            default: false
        },

        slides: {
            type: Array,
            default: () => ([])
        },
        fade: {
            type: Boolean,
            default: false
        },
        perView: {
            type: [Number, String],
            default: 1
        },
        loop: {
            type: Boolean,
            default: true
        },
        breakpointOptions: {
            type: Object,
            default: () => ({})
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        initialSlideIndex: {
            type: Number,
            default: 0
        },
        slideToClicked: {
            type: Boolean,
            default: false
        }
    },

    setup(props , { emit }) {
        const swiperInstance = ref(null);

        const onSwiper = (swiper) => {
            // console.log(swiper);
            swiperInstance.value = swiper;
        };

        const onSlideChange = (slider) => {
            emit('slideChanged', slider.realIndex)
        };

        watch(() => props.initialSlideIndex, newIndex => {
            if(props.loop) {
                swiperInstance.value && swiperInstance.value.slideToLoop(newIndex)
            } else {
                swiperInstance.value && swiperInstance.value.slideTo(newIndex)
            }
        })

        return {
            onSwiper,
            onSlideChange
        }
    }
}
</script>
